import React, { FC } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { Edit, ListAlt, PhoneCallback } from '@mui/icons-material';
import { StringCellValue } from '../../UI/MfResponsiveTable/MfResponsiveTable';
import { AgentRequestResponse } from '../../../structures/response/AgentRequestResponse';

interface Props {
  onEdit: (v: AgentRequestResponse) => void;
  onView: (v: AgentRequestResponse) => void;
  onCallback: (v: AgentRequestResponse) => void;
  agentRequest: AgentRequestResponse;
}

const ActionCell: FC<Props> = ({
  onEdit,
  onView,
  onCallback,
  agentRequest,
}) => (
  <StringCellValue>
    <Tooltip title="Изменить">
      <IconButton size="small" onClick={() => onEdit(agentRequest)}>
        <Edit fontSize="small" />
      </IconButton>
    </Tooltip>
    <Tooltip title="Подробнее">
      <IconButton size="small" onClick={() => onView(agentRequest)}>
        <ListAlt fontSize="small" />
      </IconButton>
    </Tooltip>
    <Tooltip title="Запросить консультацию">
      <IconButton size="small" onClick={() => onCallback(agentRequest)}>
        <PhoneCallback fontSize="small" />
      </IconButton>
    </Tooltip>
  </StringCellValue>
);

export default ActionCell;
